import React from 'react';
import { X } from 'lucide-react';
import T from 'Components/Helpers/translate';

export type ModalField = { key: string; label: string; value: string; half?: boolean };

type Props = {
	title: string;
	fields: ModalField[];
	actionLabel: string;
	saving: boolean;
	actionDisabled?: boolean;
	// Info-view mode (e.g. company already in Upsales): fields shown but not editable.
	fieldsDisabled?: boolean;
	onChange: (key: string, value: string) => void;
	onAction: () => void;
	onClose: () => void;
};

// Small in-panel modal for reviewing/editing a company or contact before adding
// it. Plain overlay (not the app modal service) — the embed runs chromeless
// inside the extension iframe.
const AddToUpsalesModal: React.FC<Props> = ({
	title,
	fields,
	actionLabel,
	saving,
	actionDisabled,
	fieldsDisabled,
	onChange,
	onAction,
	onClose
}) => (
	<>
		<div className="embed-modal-backdrop" onClick={saving ? undefined : onClose} />
		<div className="embed-modal" role="dialog" aria-label={title}>
			<div className="embed-modal-head">
				<span className="embed-modal-title">{title}</span>
				<button
					type="button"
					className="embed-icon-btn"
					title={T('default.close')}
					aria-label={T('default.close')}
					disabled={saving}
					onClick={onClose}
				>
					<X />
				</button>
			</div>
			<div className="embed-add-form embed-modal-form">
				{fields.map(field => (
					<label key={field.key} className={`embed-add-field${field.half ? ' is-half' : ''}`}>
						<span>{field.label}</span>
						<input
							value={field.value}
							disabled={saving || fieldsDisabled}
							onChange={e => onChange(field.key, e.target.value)}
						/>
					</label>
				))}
			</div>
			<button
				type="button"
				className="embed-add-btn embed-add-btn-primary"
				disabled={saving || actionDisabled}
				onClick={onAction}
			>
				{actionLabel}
			</button>
		</div>
	</>
);

export default AddToUpsalesModal;
